export var StoreType = {
  Cookie: 'cookie',
  LocalStorage: 'localStorage',
  Memory: 'memory'
};
